<template>
  <div class="brief-presupuestos-internos">
    <b-card header= "Presupuestos Internos" class="brief-header">
      <b-btn class="btn-collapse-card" 
          variant="primary" 
          size="sm"
          @click.prevent="showPresupuestosInternos= !showPresupuestosInternos">
        <i :class="showPresupuestosInternos ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="headerPresupuestosInternos" class="mt-2" v-model="showPresupuestosInternos">
        <b-row>
          <b-col>
            <b-table hover
                responsive="sm" 
                class="registro"
                :items="presupuestosInternos" 
                :fields="presupuestosInternosFields">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
            </b-table>
          </b-col>
        </b-row>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'BriefPresupuestosInternosData',
  props: {
    presupuestosInternos: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      presupuestosInternosFields: [
        {
          key: 'presupuestoNumero',
          label: 'Nro.Presupuesto',
        },
        {
          key: 'accion',
        },
      ],

      showPresupuestosInternos: false,

      labelCols: 2,
    }
  },
  created() {
  },
  destroyed() {
  },
}
</script>

<style>
  .brief-presupuestos-internos table thead th {
    border-top: none;
  }
  .brief-presupuestos-internos table td[aria-colindex="1"] {
    width: 20%;
  }
  .brief-presupuestos-internos table td[aria-colindex="2"] {
    width: 80%;
  }
</style>